import { ScaleTypes } from './../charts.model';
import { ChartsService } from './../charts.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { ScaleSequential } from 'd3-scale';

@Component({
  selector: 'app-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss'],
})
export class ChartLegendComponent implements OnInit {
  @Input()
  data: any[];
  @Input() interpolation: (t: number) => string;
  @Input() colorScale: ScaleTypes;
  @Input() invertedColor: boolean;

  color: ScaleSequential<Output>;
  constructor(private chartsService: ChartsService) {}

  ngOnInit() {}

  setColor(i: number) {
    if (this.data[i].color) {
      return this.data[i].color;
    } else {
      this.color = this.chartsService.getColorScale(
        this.data.length,
        this.colorScale,
        this.interpolation
      );
      const domainValue = this.invertedColor ? this.data.length - 1 - i : i;
      return this.color(domainValue);
    }
  }
}
